/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-14 10:49:16
 */ 
export const vistedRecordsCn = {
    xunjiadang:'浏览记录',
    dingdangbianhao:'请输入关键字',
    sousuo:'搜索',
    quanxuan:'全选',
    sanchu:'删除',
    fuwuxinxi:'服务信息',
    zhiliaoxinxi:'资料信息',
    kechengxinxi:'课程信息',
    hzuanjiaxinxi:'专家信息',
    lioulanshijian:'浏览时间',
    caozuo:'操作',
    renzhengfuwu:'认证服务',
    ziliaowenku:'资料文库',
    peixunfuwu:'培训服务',
    zhuanjiazhixun:'专家咨询',
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/vistedRecords/vistedRecordsCn.js